(() => {
  const popup = document.querySelector('[data-osevra-promo]');
  if (!popup || window.Shopify?.designMode) return;

  const storageKey = 'osevra-promo-dismissed-v1';
  const hasFeedback = Boolean(popup.querySelector('[data-osevra-promo-feedback]'));
  if (window.localStorage.getItem(storageKey) && !hasFeedback) return;

  const close = () => {
    popup.hidden = true;
    window.localStorage.setItem(storageKey, '1');
  };

  const open = () => { popup.hidden = false; };
  if (hasFeedback) {
    window.localStorage.removeItem(storageKey);
    open();
  } else {
    window.setTimeout(open, 1200);
  }
  popup.querySelectorAll('[data-osevra-promo-close]').forEach((button) => button.addEventListener('click', close));
  popup.addEventListener('click', (event) => { if (event.target === popup) close(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !popup.hidden) close(); });
})();
